import React from "react";
import Image from "../../image";
import BlogAuthorOverview from "./blogAuthorOverview";

import heroImage from "images/blog/whatsup-bg.png";

const BlogHero = ({ post }) => {
  const featuredImage = post?.globalConfig?.backgroundImage ?? null;
  return (
    <section className="relative flex flex-col items-center justify-end sm:min-h-[610px] min-h-[490px] mx-auto">
      <Image
        imageAlt={"Blog Hero"}
        image={""}
        imageClass="absolute z-0 object-cover w-full h-full"
        sourceUrl={featuredImage?.sourceUrl ?? heroImage}
      />
      <div className="container z-10 mx-auto sm:w-10/12">
        <div className="flex justify-start">
          <div className="w-full px-4 sm:w-2/5 sm:px-0">
            <BlogAuthorOverview post={post} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default BlogHero;
